export default "__VITE_ASSET__Bn7Ib8s7__"